import { Navigate, useLocation } from 'react-router-dom';
import ChangePassword from '../views/pages/authentication/authentication3/changePassword';
import ForgetPasswordSubmit from '../views/pages/authentication/authentication3/ForgetPasswordSubmit';

export function ResetPasswordPage() {
    const { state } = useLocation();
    return state?.email ? <ForgetPasswordSubmit /> : <Navigate to="/forgetPassword" replace />;
}

export function NewPasswordPage() {
    const { state } = useLocation();
    return state?.nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED'
        ? <ChangePassword /> : <Navigate to="/login" replace />;
}
